import { isNil } from 'lodash'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

import { DepositMethod } from '@eastcoal/shared/enums/DepositMethod'

export const environmentDepositValidator: SchemaItem['x-validator'] = {
  validator(value: {
    environmentDepositMethod: DepositMethod
    environmentDepositValue?: number
  }) {
    if (value.environmentDepositMethod === DepositMethod.NONE) {
      return null
    }

    if (isNil(value.environmentDepositValue)) {
      return '环保保证金值不能为空'
    }

    return null
  }
}
